import { CheckIcon } from "lucide-react"

import { cn } from "@/lib/utils"

/**
 * Choix cliquable pleine largeur. Volontairement haut : c'est un écran
 * rempli au pouce, sur un téléphone, souvent debout.
 *
 * `role` est passé par l'appelant — `radio` pour un choix unique,
 * `checkbox` pour un choix multiple — pour que le lecteur d'écran annonce
 * le bon comportement.
 */
function OptionCard({
  label,
  hint,
  selected,
  role,
  className,
  ...props
}: Omit<React.ComponentProps<"button">, "role"> & {
  label: string
  hint?: string
  selected: boolean
  role: "radio" | "checkbox"
}) {
  return (
    <button
      type="button"
      role={role}
      aria-checked={selected}
      data-selected={selected}
      className={cn(
        "group flex w-full items-center gap-4 rounded-lg border border-border bg-card px-6 py-5 text-left transition-colors",
        "hover:border-border-strong",
        "data-[selected=true]:border-foreground data-[selected=true]:bg-foreground/[0.06]",
        className
      )}
      {...props}
    >
      <span className="flex-1">
        <span className="block font-heading text-[1.0625rem] tracking-[0.02em] uppercase">
          {label}
        </span>
        {hint ? (
          <span className="mt-1 block text-[0.875rem] text-faint">{hint}</span>
        ) : null}
      </span>

      {/* Pastille de sélection : vide au repos, elle réserve sa place pour
          que le texte ne se décale pas au clic. */}
      <span
        aria-hidden
        className="grid size-6 shrink-0 place-items-center rounded-full border border-border-strong transition-colors group-data-[selected=true]:border-foreground group-data-[selected=true]:bg-foreground"
      >
        <CheckIcon className="size-3.5 text-background opacity-0 transition-opacity group-data-[selected=true]:opacity-100" />
      </span>
    </button>
  )
}

export { OptionCard }
